import { render, staticRenderFns } from "./LeadCommunicationSuggestions.vue?vue&type=template&id=1f899dd0&scoped=true&"
import script from "./LeadCommunicationSuggestions.vue?vue&type=script&lang=js&"
export * from "./LeadCommunicationSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./LeadCommunicationSuggestions.vue?vue&type=style&index=0&id=1f899dd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f899dd0",
  null
  
)

export default component.exports